import { useEffect, useState } from "react";
import { getOurObsesions } from "../services/OurObsesions.service";

export const useOurObsessions = (sectionRef, imageRef) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchObsessions = async () => {
      try {
        const res = await getOurObsesions();
        setData(res);
      } finally {
        setLoading(false);
      }
    };

    fetchObsessions();
  }, []);

  // Zoom effect
  useEffect(() => {
    if (!data) return;
    if (window.innerWidth < 992) return;
    if (!sectionRef.current || !imageRef.current) return;

    const section = sectionRef.current;
    const image = imageRef.current;

    const START_WIDTH = 75;
    const END_WIDTH = 135;

    const onScroll = () => {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let progress =
        (windowHeight - rect.top) / (windowHeight + rect.height);

      progress = Math.max(0, Math.min(1, progress));

      const width =
        START_WIDTH + (END_WIDTH - START_WIDTH) * progress;

      image.style.width = `${width}%`;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [data, sectionRef, imageRef]);

  return { data, loading };
};